import { Link as RouterLink } from 'react-router-dom';
import { Link, Stack, Typography } from '@mui/material';
import { PATH_AUTH } from '../../routes/paths';
import AuthShell from '../../components/auth/AuthShell';
import { LoginForm } from '../../sections/auth/login';
import { APP_NAME } from '../../config';

export default function Login() {
  return (
    <AuthShell
      pageTitle="Login"
      showBack={false}
      title={`Sign in to ${APP_NAME}`}
      subtitle="Welcome back — pick up where you left off."
      footer={
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Don&apos;t have an account?
          </Typography>
          <Link
            component={RouterLink}
            to={PATH_AUTH.register}
            variant="subtitle2"
            sx={{ color: 'primary.main', fontWeight: 700 }}
          >
            Create one
          </Link>
        </Stack>
      }
    >
      <LoginForm />
    </AuthShell>
  );
}
